'use client'
import React from 'react'
import styles from './styles.module.scss'

interface CloseIconProps {
  onClickHandler?: (e: any) => void
}

const CloseIcon: React.FC<CloseIconProps> = ({ onClickHandler }) => (
  <div className={styles.container}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClickHandler}
    >
      <rect
        width="24"
        height="24"
        rx="12"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 0 0)"
        fill="transparent"
      />
      <path
        d="M16.78 8.28222C17.0733 7.98889 17.0733 7.51332 16.78 7.21999C16.4867 6.92667 16.0111 6.92667 15.7178 7.21999L12 10.9378L8.28222 7.21999C7.98889 6.92667 7.51332 6.92667 7.21999 7.21999C6.92667 7.51332 6.92667 7.98889 7.21999 8.28222L10.9378 12L7.21999 15.7178C6.92667 16.0111 6.92667 16.4867 7.21999 16.78C7.51332 17.0733 7.98889 17.0733 8.28222 16.78L12 13.0622L15.7178 16.78C16.0111 17.0733 16.4867 17.0733 16.78 16.78C17.0733 16.4867 17.0733 16.0111 16.78 15.7178L13.0622 12L16.78 8.28222Z"
        fill="curentColor"
      />
    </svg>
  </div>
)

export default React.memo(CloseIcon)
